<template>
  <section class="live-stats">
    <b-navbar>
      <template slot="start">
        <h3 class="title">Live stats</h3>
      </template>
      <template slot="end">
        <b-checkbox v-model="showEnqueued">Enqueued</b-checkbox>
        <b-checkbox v-model="showStarted">Started</b-checkbox>
        <b-checkbox v-model="showFailed">Failed</b-checkbox>
        <b-checkbox v-model="showFinished">Finished</b-checkbox>
        <chart-compare-selector v-model="compareWorkers" @input="handleCompareChange" />
        <chart-scope-selector :value="startTime" @input="handleScopeChange" />
      </template>
    </b-navbar>

    <div class="charts">
      <chart-processing
        title="All tasks"
        :isFetching="isLoading"
        :showEnqueued="showEnqueued"
        :showStarted="showStarted"
        :showFailed="showFailed"
        :showFinished="showFinished"
        :series="stats" />

      <template v-if="compareWorkers">
        <chart-processing
          v-for="workerStats in statsPerWorker"
          :key="workerStats.label"
          :title="workerStats.label"
          :isFetching="isLoading"
          :showEnqueued="showEnqueued"
          :showStarted="showStarted"
          :showFailed="showFailed"
          :showFinished="showFinished"
          :series="workerStats.series" />
      </template>

    </div>
  </section>
</template>

<script>
  import format from 'date-fns/format'
  import { fetchInfluxEvents } from '@/api'
  import ChartProcessing from '@/components/ChartProcessing'
  import ChartScopeSelector from '@/components/ChartScopeSelector'
  import ChartCompareSelector from '@/components/ChartCompareSelector'

  export default {
    name: 'LiveStats',
    components: { ChartProcessing, ChartScopeSelector, ChartCompareSelector },
    data () {
      return {
        isLoading: true,
        groupBy: '10m',
        startTime: '6h',
        showEnqueued: true,
        showStarted: true,
        showFailed: true,
        showFinished: false,
        workers: [ // FIXME: pull workers list from backend
          'pdf001.local',
          'pdf002.local',
        ],
        compareWorkers: false,
        stats: [],
        statsPerWorker: []
      }
    },
    mounted() {
      this.fetchStats()

      // FIXME: any better solution for periodical pulling data?
      this.tickHandler = setInterval(() => {
          this.fetchStats()
      }, 60 * 1000)
    },
    beforeDestroy () {
      clearInterval(this.tickHandler)
    },
    computed: {

    },
    methods: {
      formatDate (dt, formatStr = 'yyy-MM-dd') {
        return format(dt, formatStr)
      },
      async fetchStats () {
        this.isLoading = true
        const groupBy = this.groupBy
        const startTime = this.startTime
        try {
          console.log('will pull general stats')
          this.stats = await fetchInfluxEvents(groupBy, startTime)
          if (this.compareWorkers) {
            this.statsPerWorker = await Promise.all(
              this.workers.map(async wrk => ({
                label: wrk,
                series: await fetchInfluxEvents(groupBy, startTime, wrk)
              }))
            )
          }
        } catch {
          this.$buefy.toast.open({
            message: `Failed loading live stats. An error occurred.`,
            type: 'is-danger'
          })
        }
        this.isLoading = false
      },
      handleScopeChange (val) {
        this.startTime = val.startTime
        this.groupBy = val.groupBy
        this.fetchStats()
      },
      handleCompareChange () {
        this.fetchStats()
      }
    }
  }
</script>
